export function returnUtm(link, campaign, source, medium, term, content) {
    return "".concat(link, "?utm_campaign=").concat(campaign, "&utm_source=").concat(source, "&utm_medium=").concat(medium, "&utm_term=").concat(term, "&utm_content=").concat(content);
}
export function getProjectsByOwnerUrl(id, username) {
    return "/projects/team?ownerId=".concat(id, "&ownerUsername=").concat(username);
}
